import { ContentAssociationValidation } from "../../../../common/content/types/AssociateContentFormValidationRules";
import { getAssociateFileRecordValidationRules } from "../../common/utils/getAssociateFileRecordValidationRules";
import { useCreateFileRecordState } from "../hooks/state/useCreateFileRecordState";
import { mapToFileRecordContentAssociationFormState } from "./mapToFileRecordContentAssociationFormState";
import { useSourceFileRecordDetails } from "./useSourceFileRecordDetails";

export const useCreateFileRecordAssociateContentForm = () => {
    const { form, isLoading: isDefaultStateLoading } = useCreateFileRecordState();

    const { data: fileRecordDetails, isLoading: areFileRecordDetailsLoading } = useSourceFileRecordDetails();

    const validation = getFileRecordContentAssociatioValidation();

    return {
        defaultContentState: fileRecordDetails
            ? mapToFileRecordContentAssociationFormState(fileRecordDetails)
            : undefined,
        isDefaultContentLoading: areFileRecordDetailsLoading || isDefaultStateLoading,
        validation,
        form
    };
};

const getFileRecordContentAssociatioValidation = (): ContentAssociationValidation => {
    return { rules: getAssociateFileRecordValidationRules() };
};
